module.exports = __webpack_public_path__ + "static/media/1021015.a70f88a3.png";